import type { Element } from '@xmldom/xmldom'
import L6ToL5TagProcessor from "./TagProcessor"
import { DefaultProps, applyDefaultCid } from "./DefaultProps"

class GenericTagProcessor extends L6ToL5TagProcessor {
	process(node: Element, defaultProps: DefaultProps): boolean {
		if(!this.rootProc.translateDirItemId(node, 'dirItemId', 'cid', true)) {
			return false
		}
		applyDefaultCid(node, defaultProps)
		return true
	}
}

export default GenericTagProcessor
